import { ApiClient } from "../ApiClient";

/**
 * Request a short-lived, single-use PushRegistrationIntent for the
 * currently authenticated session on Android or iOS. Response: `{ intent_token, expires_at }`.
 *
 * SECURITY: the caller must never log or persist the returned
 * `intent_token` — it is a single-use credential meant only for an
 * immediate hand-off to the native bridge.
 *
 * @returns {Promise<Response>} the raw fetch Response.
 */
export async function requestPushRegistrationIntent(platform) {
  if (platform !== "android" && platform !== "ios") {
    throw new TypeError("Unsupported native push platform");
  }
  return ApiClient.post("/notifications/devices/registration-intent", {
    platform,
  });
}
